import React, { useState } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import styles from './index.module.less';
import {
  COMMISSION_MONTHS,
  COMMISSION_RATE,
  ELITE_PLAN_MONTHLY_PRICE,
  REFERRAL_MAX,
  REFERRAL_MIN,
  REFERRAL_TICKS,
} from '../../constants';

/** 收益计算器：设计稿 #10899:3693 / #10899:3694 */
const EarningsCalculator: React.FC = () => {
  const { t } = useTranslation('common');
  const [count, setCount] = useState(REFERRAL_MIN);

  const total = count * ELITE_PLAN_MONTHLY_PRICE * COMMISSION_MONTHS * COMMISSION_RATE;
  const [whole, cents] = total.toFixed(2).split('.');
  // 固定用 en-US 千分位：金额以美元计价，也避免 SSR 与客户端 locale 不一致导致 hydration 报错
  const wholeText = Number(whole).toLocaleString('en-US');

  return (
    <div className={styles.wrapper}>
      <div className={styles.panel}>
        <div className={styles.row}>
          <div className={styles.left}>
            {/* #10899:3697 */}
            <div className={styles.eyebrow}>
              <span className={styles.eyebrowDash} />
              <span className={styles.eyebrowText}>{t('See What You Could Earn')}</span>
            </div>

            {/* #10899:3701，数字部分单独着色 */}
            <p className={styles.question}>
              <Trans
                i18nKey="AffiliateReferCreators"
                values={{ count }}
                components={{ countSpan: <span className={styles.count} /> }}
              />
            </p>

            {/* #10899:3702 */}
            <div className={styles.sliderBlock}>
              {/* 轨道画在外层：input 比轨道宽一个滑块直径并左右各外移半个，
                  这样滑块「圆心」在最小/最大值时正好落在轨道两端，而不是留半个身位 */}
              <div className={styles.sliderTrack}>
                <input
                  type="range"
                  className={styles.slider}
                  min={REFERRAL_MIN}
                  max={REFERRAL_MAX}
                  step={1}
                  value={count}
                  onChange={(e) => setCount(Number(e.target.value))}
                  aria-label={t('See What You Could Earn')}
                  aria-valuetext={String(count)}
                />
              </div>
              {/* 刻度按数值比例定位，中心与该值对应的滑块圆心重合 */}
              <div className={styles.ticks} aria-hidden="true">
                {REFERRAL_TICKS.map((tick) => (
                  <span
                    key={tick}
                    style={{ left: `${((tick - REFERRAL_MIN) / (REFERRAL_MAX - REFERRAL_MIN)) * 100}%` }}
                  >
                    {tick}
                  </span>
                ))}
              </div>
            </div>

            {/* #10899:3712 */}
            <p className={styles.basedOn}>{t('Based on Erasa’s $299/month Elite Plan')}</p>
          </div>

          {/* #10899:3713 */}
          <div className={styles.right}>
            <div className={styles.card}>
              <img
                className={styles.coins}
                src="/images/affiliate-program/coins.webp"
                alt=""
                width={282}
                height={240}
              />
              {/* #10899:3716，小数部分字号 42、整数 64 */}
              <p className={styles.amount} aria-live="polite">
                <span className={styles.amountWhole}>${wholeText}</span>
                <span className={styles.amountCents}>.{cents}</span>
              </p>
              <p className={styles.amountLabel}>{t('Estimated commission over 6 months')}</p>
            </div>
          </div>
        </div>

        {/* #10899:3718 */}
        <p className={styles.disclaimer}>
          {t('Estimated earnings are based on the actual amount paid by each referred customer.')}
        </p>
      </div>
    </div>
  );
};

export default EarningsCalculator;
